module.exports = __webpack_public_path__ + "static/img/20250324185203.19ac205.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20250324185203.png
// module id = X7gy
// module chunks = 1